<template>
  <div class="app-change-password-wrapper">
    <ChangePasswordView v-if="showView" nextStep="input">
      <template #txtBefore><slot name="txtBeforeView"></slot></template>
      <template #labelPassword><slot name="labelPasswordView"></slot></template>
      <template #txtPasswordMask><slot name="txtPasswordMaskView"></slot></template>
      <template #btnNext><slot name="btnNextView"></slot></template>
      <template #txtAfter><slot name="txtAfterView"></slot></template>
    </ChangePasswordView>
    <ChangePasswordInput v-if="showInput" nextStep="success" previousStep="view">
      <template #txtBefore><slot name="txtBeforeInput"></slot></template>
      <template #oldPasswordLabelTxt><slot name="oldPasswordLabelTxt"></slot></template>
      <template #passwordLabelTxt><slot name="passwordLabelTxt"></slot></template>
      <template #passwordRepeatLabelTxt><slot name="passwordRepeatLabelTxt"></slot></template>
      <template #passwordLiveFeedback><slot name="passwordLiveFeedback"></slot></template>
      <template #btnPrev><slot name="btnPrevInput"></slot></template>
      <template #btnNext><slot name="btnNextInput"></slot></template>
      <template #txtAfter><slot name="txtAfterInput"></slot></template>
    </ChangePasswordInput>
    <ChangePasswordThankYou v-if="showThankYou" previousStep="view">
      <template #txtBefore><slot name="txtBeforeThankYou"></slot></template>
      <template #btnPrev><slot name="btnPrevThankYou"></slot></template>
      <template #txtAfter><slot name="txtAfterThankYou"></slot></template>
    </ChangePasswordThankYou>
  </div>
</template>
<script>
import ChangePasswordView, { stepName as viewStepName } from './View.vue'
import ChangePasswordInput, { stepName as inputStepName } from './Input.vue'
import ChangePasswordThankYou, { stepName as thankYouStepName } from './ThankYou.vue'
import { mapGetters } from 'vuex'
import transaction from '@/mixins/transaction'

export default {
  name: 'ChangePasswordWrapper',
  components: { ChangePasswordView, ChangePasswordInput, ChangePasswordThankYou },
  mixins: [
    transaction('changePassword')
  ],
  computed: {
    ...mapGetters('changePassword', [
      'currentStep'
    ]),
    showView () {
      return this.currentStep === viewStepName
    },
    showInput () {
      return this.currentStep === inputStepName
    },
    showThankYou () {
      return this.currentStep === thankYouStepName
    }
  }
}
</script>
